import { io } from "socket.io-client";

let socket = null;
let socketKey = "";
let socketRefCount = 0;

function getSocketBase() {
  const raw = import.meta.env.VITE_API_BASE_URL || "";
  return raw.replace(/\/api\/?$/, "");
}

function buildSocketKey(authInput = {}) {
  if (typeof authInput === "string") {
    return `access:${authInput}`;
  }

  if (authInput && typeof authInput === "object") {
    if (authInput.gameToken) return `game:${authInput.gameToken}`;
    if (authInput.accessToken) return `access:${authInput.accessToken}`;
  }

  return "anon";
}

export function connectSocket(authInput = {}) {
  const nextKey = buildSocketKey(authInput);

  if (socket && socketKey !== nextKey) {
    socket.disconnect();
    socket = null;
    socketKey = "";
    socketRefCount = 0;
  }

  if (socket) {
    socketRefCount += 1;
    return socket;
  }

  let accessToken = null;
  let gameToken = null;

  if (typeof authInput === "string") {
    accessToken = authInput;
  } else if (authInput && typeof authInput === "object") {
    accessToken = authInput.accessToken || null;
    gameToken = authInput.gameToken || null;
  }

  const auth = {};
  if (gameToken) auth.game_token = gameToken;
  else if (accessToken) auth.access_token = accessToken;

  socket = io(getSocketBase(), {
    transports: ["websocket"],
    auth,
  });
  socketKey = nextKey;
  socketRefCount = 1;

  return socket;
}

export function getSocket() {
  return socket;
}

export function releaseSocket() {
  if (!socket) return;

  socketRefCount = Math.max(0, socketRefCount - 1);
  if (socketRefCount === 0) {
    socket.disconnect();
    socket = null;
    socketKey = "";
  }
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
    socketKey = "";
    socketRefCount = 0;
  }
}
